<div class="studio-tab">
  @if (view() === 'form') {
    <div class="studio-form">
      <p class="regular-14 color-soft-grey">{{ 'cardsAdminStudioIntro' | transloco }}</p>
      @if (error(); as err) {
        <p class="regular-14 color-red">{{ err | transloco }}</p>
        @if (err === 'cardsAdminStudioFailed' && run()?.studio?.error) {
          <p class="regular-12 color-soft-grey">{{ run()?.studio?.error }}</p>
        }
      }
      <div class="form-grid">
        <div class="form-field">
          <label class="semibold-12">{{ 'cardsAdminNameEn' | transloco }}</label>
          <input class="text-input" [formControl]="nameEnControl" maxlength="60" />
        </div>
        <div class="form-field">
          <label class="semibold-12">{{ 'cardsAdminNameUk' | transloco }}</label>
          <input class="text-input" [formControl]="nameUkControl" maxlength="60" />
        </div>
        <div class="form-field">
          <label class="semibold-12">{{ 'cardsAdminQuoteEn' | transloco }}</label>
          <input class="text-input" [formControl]="quoteEnControl" maxlength="140" />
        </div>
        <div class="form-field">
          <label class="semibold-12">{{ 'cardsAdminQuoteUk' | transloco }}</label>
          <input class="text-input" [formControl]="quoteUkControl" maxlength="140" />
        </div>
      </div>
      <div class="suggest-row">
        <button class="secondary-bar-btn" [disabled]="suggesting()" (click)="suggestQuotes()">
          {{ (suggesting() ? 'cardsAdminStudioSuggesting' : 'cardsAdminStudioSuggest') | transloco }}
        </button>
        @for (s of suggestions(); track s.en) {
          <button class="suggestion-chip regular-12" (click)="applySuggestion(s)">{{ s.en }} / {{ s.uk }}</button>
        }
      </div>
      <div class="form-field">
        <label class="semibold-12">{{ 'cardsAdminStudioDescription' | transloco }}</label>
        <textarea class="text-input" rows="3" [formControl]="descriptionControl" maxlength="600"
                  [placeholder]="'cardsAdminStudioDescriptionHint' | transloco"></textarea>
      </div>
      <div class="form-field">
        <label class="semibold-12">{{ 'cardsAdminStudioHintLabel' | transloco }}</label>
        <input class="text-input" [formControl]="hintControl" maxlength="200" />
      </div>
      <div class="form-field rarity-field">
        <label class="semibold-12">{{ 'cardsAdminStudioRarity' | transloco }}</label>
        <select class="text-input" [formControl]="rarityControl">
          <option value="common">{{ 'cardsAdminStudioRarityCommon' | transloco }}</option>
          <option value="rare">{{ 'cardsAdminStudioRarityRare' | transloco }}</option>
          <option value="legendary">{{ 'cardsAdminStudioRarityLegendary' | transloco }}</option>
          <option value="mythic">{{ 'cardsAdminStudioRarityMythic' | transloco }}</option>
        </select>
      </div>
      <button class="primary-btn" [disabled]="!canGenerate()" (click)="generate()">
        {{ 'cardsAdminStudioGenerate' | transloco }}
      </button>
    </div>
  }
  @if (view() === 'generating') {
    <div class="studio-generating">
      <p class="semibold-14">{{ 'cardsAdminStudioGenerating' | transloco }} {{ run()?.studio?.progress || '' }}</p>
      @if (run()?.studio?.anchorImageUrl; as anchorUrl) {
        <div class="anchor-row">
          <span class="regular-12 color-soft-grey">{{ 'cardsAdminStudioAnchor' | transloco }}</span>
          <img class="anchor-thumb" [src]="anchorUrl" />
        </div>
      }
      <div class="candidates-grid">
        @for (c of run()?.candidates ?? []; track c.id) {
          <img class="candidate-image" [src]="c.imageUrl" [alt]="c.name.en" />
        }
      </div>
      <p class="regular-12 color-soft-grey">{{ 'cardsAdminStudioGeneratingHint' | transloco }}</p>
      <button class="warning-bar-btn stop-btn" [disabled]="stopping()" (click)="stopGeneration()">
        {{ 'cardsAdminStudioStopBtn' | transloco }}
      </button>
    </div>
  }
  @if (view() === 'review') {
    <div class="studio-review">
      <p class="semibold-14">{{ 'cardsAdminStudioPick' | transloco }}</p>
      @if (run()?.studio?.error; as detail) {
        <!-- Partial salvage: some candidates failed but these survived. -->
        <p class="regular-12 color-soft-grey">{{ detail }}</p>
      }
      <div class="candidates-grid">
        @for (c of run()?.candidates ?? []; track c.id) {
          <img class="candidate-image selectable" [class.selected]="selectedCandidateId() === c.id"
               [src]="c.imageUrl" [alt]="c.name.en" (click)="selectCandidate(c.id)" />
        }
      </div>
      @if (selectedCandidateId() !== null) {
        <div class="iterate-block">
          <textarea class="text-input" rows="2" [formControl]="feedbackControl" maxlength="600"
                    [placeholder]="'cardsAdminStudioFeedbackHint' | transloco"></textarea>
          <div class="actions-row">
            <button class="secondary-btn" [disabled]="starting()" (click)="iterate()">
              {{ 'cardsAdminStudioIterate' | transloco }}
            </button>
            <button class="primary-btn" (click)="openPublish()">{{ 'cardsAdminPublish' | transloco }}</button>
          </div>
        </div>
      }
      <div class="display-flex gap-12">
        <button class="secondary-bar-btn start-new" (click)="startNew()">{{ 'cardsAdminStudioStartNew' | transloco }}</button>
        <button class="warning-bar-btn" [disabled]="deleting()" (click)="showDeleteModal.set(true)">{{ 'cardsAdminDeleteRun' | transloco }}</button>
      </div>
    </div>
  }
  @if (view() === 'published') {
    <div class="studio-published">
      <p class="semibold-14 color-green">{{ 'cardsAdminStudioPublishedTitle' | transloco }}</p>
      @if (selectedCandidate(); as c) {
        <img class="candidate-image" [src]="c.imageUrl" [alt]="c.name.en" />
        <p class="regular-14">{{ publishNameEnControl.value }} / {{ publishNameUkControl.value }}</p>
      }
      <button class="primary-btn" (click)="startNew()">{{ 'cardsAdminStudioStartNew' | transloco }}</button>
    </div>
  }
  @if (showPublishModal()) {
    <app-modal [title]="'cardsAdminPublish' | transloco" [footerButtons]="publishModalButtons"
               (closeEvent)="closePublish()">
      <div class="publish-modal-body">
        <p class="regular-12 color-soft-grey">{{ 'cardsAdminPublishWarning' | transloco }}</p>
        @if (publishError(); as err) {
          <p class="regular-14 color-red">{{ err | transloco }}</p>
        }
        <label class="semibold-12">{{ 'cardsAdminNameEn' | transloco }}</label>
        <input class="text-input" [formControl]="publishNameEnControl" maxlength="60" />
        <label class="semibold-12">{{ 'cardsAdminNameUk' | transloco }}</label>
        <input class="text-input" [formControl]="publishNameUkControl" maxlength="60" />
        <label class="semibold-12">{{ 'cardsAdminQuoteEn' | transloco }}</label>
        <input class="text-input" [formControl]="publishQuoteEnControl" maxlength="140" />
        <label class="semibold-12">{{ 'cardsAdminQuoteUk' | transloco }}</label>
        <input class="text-input" [formControl]="publishQuoteUkControl" maxlength="140" />
      </div>
    </app-modal>
  }
  @if (showDeleteModal()) {
    <app-modal [title]="'areYouSureQ' | transloco" [footerButtons]="deleteModalButtons"
               (closeEvent)="showDeleteModal.set(false)">
      <p class="regular-14 color-red">{{ 'cardsAdminDeleteRunWarning' | transloco }}</p>
    </app-modal>
  }
</div>
